export default {
  //@ts-ignore
  TOGGLE_MENU(state, payload: Boolean) {
    state.isMenu = payload;
  },
};
